import { render, staticRenderFns } from "./TheadCompliance.vue?vue&type=template&id=9e2bb85e"
import script from "./TheadCompliance.vue?vue&type=script&lang=js"
export * from "./TheadCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports